import { z } from 'zod';
import {
  IdSchema,
  ImageRefSchema,
  IsoDateSchema,
  SlugSchema,
  UrlSchema,
} from './primitives.js';
import { PaginationSchema } from './pagination.js';

export const ArtistSchema = z.object({
  id: IdSchema,
  slug: SlugSchema,
  name: z.string(),
  tagline: z.string().optional(),
  bio: z.string().optional(),
  genres: z.array(z.string()).default([]),
  avatar: ImageRefSchema.optional(),
  cover: ImageRefSchema.optional(),
  gallery: z.array(ImageRefSchema).default([]),
  socials: z
    .object({
      spotify: UrlSchema.optional(),
      instagram: UrlSchema.optional(),
      youtube: UrlSchema.optional(),
      website: UrlSchema.optional(),
    })
    .default({}),
  followerCount: z.number().int().nonnegative().default(0),
  createdAt: IsoDateSchema,
  updatedAt: IsoDateSchema,
});

export const ArtistsQuerySchema = PaginationSchema.extend({
  q: z.string().optional(),
  genre: z.string().optional(),
});

export type Artist = z.infer<typeof ArtistSchema>;
export type ArtistsQuery = z.infer<typeof ArtistsQuerySchema>;
